/**
 *  返回 Unicode 字符长度 tdesign 源码方法，用于解析输入字符长度
 * '👨'.length === 2
 * getUnicodeLength('👨') === 1
 * @param str
 * @returns
 */
export function getUnicodeLength(str?: string): number {
  return [...(str ?? '')].length;
}
